import { render, staticRenderFns } from "./commodityPriceModal.vue?vue&type=template&id=724be851"
import script from "./commodityPriceModal.vue?vue&type=script&lang=js"
export * from "./commodityPriceModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports